import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '@environments/environment';
import { DataService } from '@app/_services/data.service';
import { AssetGroup } from '@app/_models/_DTOs/assetGroup';

@Injectable({ providedIn: 'root' })
export class AssetGroupService extends DataService<AssetGroup> {
    constructor(http: HttpClient) {
        super(http, "api/assetgroups")
    }
}